// Core
import React, { Suspense } from "react";
import { Routes, BrowserRouter, Route } from "react-router-dom";

// Components
import Loader from "components/Loader";
import Home from "pages/home";
import Header from "components/Header";
import { PageWrapper } from "./styles";
import Footer from "components/Footer";
import Contact from "pages/contact";


const AppRouter: React.FC = () => {

    return (
        <BrowserRouter>
            <PageWrapper>
                <Header />
                <Suspense fallback={<Loader size="large" fullscreen />}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/home" element={<Home />} />
                        <Route path="/contact" element={<Contact />} />
                        {/* <Route path="*" element={<PageNotFound />} /> */}
                    </Routes>
                </Suspense>
                <Footer />
            </PageWrapper>
        </BrowserRouter>
    );
};
export default AppRouter;
